import { Tooltip } from "react-tooltip";
import { Helper } from "../../packages/services";
import { COUNTRY_LIST } from "../../utils";

const tooltipStyle = {
    backgroundColor: "rgb(255, 255, 255)",
    boxShadow: "0 0 57px 0 rgba(167, 167, 252, 0.3)",
    padding: "8px",
    borderRadius: "4px",
    maxWidth: "700px",
};

const CmpTooltip = (props) => {
    const { id } = props;
    return (
        <Tooltip anchorSelect={`#${id}`} style={tooltipStyle}>
            {props.children}
        </Tooltip>
    );
};

export default CmpTooltip;

export const CountryTooltip = ({ countryList, id }) => {
    if (countryList && countryList.length > 0) {
        const _countryList = countryList.filter((item) => item !== "");
        const firstTwoCountries = _countryList.slice(0, 2);
        const restCountries = _countryList.slice(2);

        return (
            <>
                {firstTwoCountries.map((item, index) => {
                    if (item !== "") {
                        return (
                            <div className="country_item" key={index}>
                                {COUNTRY_LIST[item] || item}
                            </div>
                        );
                    }
                    return null;
                })}
                {restCountries.length > 0 && (
                    <div className="country_item" id={id}>
                        ...
                    </div>
                )}
                {restCountries.length > 0 && (
                    <Tooltip anchorSelect={`#${id}`} clickable style={tooltipStyle}>
                        {restCountries.map((item, index) => {
                            if (item !== "") {
                                return (
                                    <div className="country_item" key={index}>
                                        {COUNTRY_LIST[item] || item}
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </Tooltip>
                )}
            </>
        );
    }

    return null;
};

export const GetBasicLoginAppNameTooltip = ({ appList, id }) => {
    const filteredAppList =
        appList &&
        appList.length > 0 &&
        appList.filter((item) => item !== "" && item !== "auth_public" && item !== "basic_login");

    if (filteredAppList && filteredAppList.length > 0) {
        const firstTwoApp = filteredAppList.slice(0, 2);
        const restApp = filteredAppList.slice(2);

        return (
            <>
                {firstTwoApp.map((item, index) => {
                    if (Helper.GetBasicLoginAppName(item)) {
                        return (
                            <div className="country_item" key={index}>
                                {Helper.GetBasicLoginAppName(item)}
                            </div>
                        );
                    }
                    return null;
                })}
                {restApp.length > 1 && (
                    <div className="country_item" id={id}>
                        ...
                    </div>
                )}
                {restApp.length > 0 && (
                    <Tooltip anchorSelect={`#${id}`} clickable style={tooltipStyle}>
                        {restApp.map((item, index) => {
                            if (Helper.GetBasicLoginAppName(item)) {
                                return (
                                    <div className="country_item" key={index}>
                                        {Helper.GetBasicLoginAppName(item)}
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </Tooltip>
                )}
            </>
        );
    }

    return null;
};
